/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePages32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            d="M9 3h9.586a1 1 0 01.707.293l6.414 6.414a1 1 0 01.293.707V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            fill="#FB8517"
        />
        <path
            d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            fill="#fff"
            fillOpacity={0.5}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.686 24.179H11.52l-1.418.63h11.583c.173 0 .314-.14.314-.314v-.002a.314.314 0 00-.314-.314z"
            fill="#FFC78A"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.42 23.653l-.399.683a.158.158 0 00.216.216l.683-.399-.5-.5zM9.653 23.256l.664.664c.049.05.124.06.185.028a7.674 7.674 0 001.863-1.368l3.427-3.427-1.372-1.372-3.427 3.427a7.677 7.677 0 00-1.368 1.863.158.158 0 00.028.185zM16.107 18.838a.158.158 0 00.223 0l.785-.804c4.412-4.412 4.727-5.515 4.333-5.91-.394-.393-1.497-.078-5.909 4.334l-.804.785a.158.158 0 000 .223l1.372 1.372z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default FilePages32;
